import { css, Global } from "@emotion/react";

const globalStyles = css`
  .MuiTypography-root {
    font-size: 12px !important;
    padding: 0 !important;
  }
`;
const SC = {
  GlobalStyles: <Global styles={globalStyles} />,
};
export default SC;
